"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GameVars_1 = require("./../GameVars");
var ConnectionManager_1 = require("./../ConnectionManager");
var GameConstants_1 = require("../GameConstants");
var BoardState_1 = require("./BoardState");
var Pile_1 = require("./cards/Pile");
var LocalServer_1 = require("../LocalServer");
var BoardManager = /** @class */ (function () {
    function BoardManager(game) {
        BoardManager.currentInstance = this;
        this.game = game;
        GameVars_1.GameVars.draggedCard = null;
        this.cardsOnBoard = false;
        this.game.input.enabled = false;
        this.loadLocalStorage();
        GameVars_1.GameVars.paused = false;
        GameVars_1.GameVars.waitingServer = false;
    }
    BoardManager.prototype.startGame = function () {
        GameVars_1.GameVars.gameEnded = GameConstants_1.GameConstants.NO_FINAL;
        GameVars_1.GameVars.cards = [];
        // TODO: API should generate this seed for both players
        var seed;
        if (ConnectionManager_1.ConnectionManager.isBattle) {
            seed = ConnectionManager_1.ConnectionManager.gameConfig;
        }
        else {
            seed = Math.ceil(Math.random() * 500);
        }
        if (GameVars_1.GameVars.gzpGameMode !== "casual") {
            ConnectionManager_1.ConnectionManager.socket.emit("get_deck", { seed: seed, id: GameVars_1.GameVars.initialID });
        }
        else {
            LocalServer_1.LocalServer.getDeck(seed, this);
        }
    };
    BoardManager.prototype.initialCards = function (data) {
        GameVars_1.GameVars.cards = data.cards;
        BoardState_1.BoardState.currentInstance.board.putCards();
        GameVars_1.GameVars.pilesData = data.pilesData;
        this.game.time.events.add(1000, function () {
            for (var i = 0; i < GameVars_1.GameVars.cards.length; i++) {
                BoardState_1.BoardState.currentInstance.board.cards[i].visible = true;
            }
            this.putFirstCards();
            // Partida ya terminada
            // GameVars.cards = [];
            // GameVars.pilesData = [{"cards": [{"suit": 3, "value": 1}, {"suit": 3, "value": 2}, {"suit": 3, "value": 3}, {"suit": 3, "value": 4}, {"suit": 3, "value": 5}], "flipped": 0}, {"cards": [{"suit": 0, "value": 1}, {"suit": 0, "value": 2}, {"suit": 0, "value": 3}, {"suit": 0, "value": 4}, {"suit": 0, "value": 5}, {"suit": 0, "value": 6}], "flipped": 0}, {"cards": [{"suit": 1, "value": 1}, {"suit": 1, "value": 2}, {"suit": 1, "value": 3}, {"suit": 1, "value": 4}, {"suit": 1, "value": 5}], "flipped": 0}, {"cards": [{"suit": 2, "value": 1}, {"suit": 2, "value": 2}, {"suit": 2, "value": 3}, {"suit": 2, "value": 4}], "flipped": 0}, {"cards": [{"suit": 3, "value": 13}, {"suit": 0, "value": 12}, {"suit": 1, "value": 11}, {"suit": 2, "value": 10}, {"suit": 1, "value": 9}, {"suit": 0, "value": 8}, {"suit": 1, "value": 7}, {"suit": 2, "value": 6}], "flipped": 0}, {"cards": [{"suit": 0, "value": 13}, {"suit": 3, "value": 12}, {"suit": 0, "value": 11}, {"suit": 3, "value": 10}, {"suit": 0, "value": 9}, {"suit": 3, "value": 8}, {"suit": 2, "value": 7}, {"suit": 1, "value": 6}, {"suit": 2, "value": 5}], "flipped": 0}, {"cards": [{"suit": 1, "value": 8}, {"suit": 0, "value": 7}, {"suit": 3, "value": 6}], "flipped": 0}, {"cards": [], "flipped": 0}, {"cards": [{"suit": 2, "value": 13}, {"suit": 1, "value": 12}, {"suit": 2, "value": 11}, {"suit": 1, "value": 10}, {"suit": 2, "value": 9}], "flipped": 0}, {"cards": [], "flipped": 0}, {"cards": [{"suit": 1, "value": 13}, {"suit": 2, "value": 12}, {"suit": 3, "value": 11}, {"suit": 0, "value": 10}, {"suit": 3, "value": 9}, {"suit": 2, "value": 8}, {"suit": 3, "value": 7}], "flipped": 0}, {"cards": [], "flipped": 0}, {"cards": [], "flipped": 0}];
            // BoardManager.currentInstance.completeCards();
            // BoardState.currentInstance.startedGame();
        }, this);
    };
    BoardManager.prototype.startedGame = function () {
        for (var i = 0; i < GameVars_1.GameVars.cards.length; i++) {
            BoardState_1.BoardState.currentInstance.board.cards[i].visible = true;
        }
        // BoardManager.currentInstance.putCards();
    };
    BoardManager.prototype.loadLocalStorage = function () {
        GameVars_1.GameVars.moves = 0;
        GameVars_1.GameVars.points = 0;
        GameVars_1.GameVars.time = 300;
    };
    BoardManager.prototype.needPutCards = function () {
        this.startGame();
    };
    BoardManager.prototype.completeCards = function () {
        for (var i = 0; i < GameVars_1.GameVars.pilesData.length; i++) {
            for (var j = 0; j < GameVars_1.GameVars.pilesData[i].cards.length; j++) {
                GameVars_1.GameVars.cards.push(GameVars_1.GameVars.pilesData[i].cards[j]);
            }
        }
        BoardState_1.BoardState.currentInstance.board.putCards();
    };
    BoardManager.prototype.putCardsFromServer = function () {
        var board = BoardState_1.BoardState.currentInstance.board;
        board.dealPile.piledCards = [];
        board.dealPile.piledCardsAux = [];
        for (var i = 0; i < board.piles.length; i++) {
            board.piles[i].piledCards = [];
        }
        for (var i = 0; i < GameVars_1.GameVars.pilesData.length; i++) {
            var flipped = GameVars_1.GameVars.pilesData[i].flipped;
            for (var j = 0; j < GameVars_1.GameVars.pilesData[i].cards.length; j++) {
                for (var k = 0; k < board.cards.length; k++) {
                    if (board.cards[k].cardValue.suit === GameVars_1.GameVars.pilesData[i].cards[j].suit && board.cards[k].cardValue.value === GameVars_1.GameVars.pilesData[i].cards[j].value) {
                        if (i < 11) {
                            board.cards[k].move(j >= flipped, board.piles[i]);
                        }
                        else if (i === 11) {
                            board.dealPile.piledCardsAux.push(board.cards[k]);
                            board.cards[k].flip2();
                            board.cards[k].position.set(658 - 109 + 53, GameConstants_1.GameConstants.DEALPILE_Y);
                        }
                        else {
                            board.cards[k].unflip2();
                            board.dealPile.piledCards.push(board.cards[k]);
                        }
                        break;
                    }
                }
            }
        }
        this.cardsPositions();
        // this.saveChange();
    };
    BoardManager.prototype.putFirstCards = function () {
        if (this.cardsOnBoard || !GameVars_1.GameVars.pilesData) {
            return;
        }
        this.cardsOnBoard = true;
        var count = 0;
        var board = BoardState_1.BoardState.currentInstance.board;
        this.game.input.enabled = false;
        var _loop_1 = function (i) {
            var flipped = GameVars_1.GameVars.pilesData[i].flipped;
            var _loop_2 = function (j) {
                if (i < 11) {
                    var countAux_1 = count;
                    this_1.game.time.events.add(count * 100, function () {
                        BoardState_1.BoardState.currentInstance.board.cards[countAux_1].firstMove(j >= flipped, count, board.piles[i]);
                    }, this_1);
                }
                else if (i === 11) {
                    board.dealPile.piledCardsAux.push(board.cards[count]);
                    board.cards[count].flip();
                    board.cards[count].position.set(658 - 109 + 53, GameConstants_1.GameConstants.DEALPILE_Y);
                }
                else {
                    board.dealPile.piledCards.push(board.cards[count]);
                }
                count++;
            };
            for (var j = 0; j < GameVars_1.GameVars.pilesData[i].cards.length; j++) {
                _loop_2(j);
            }
            if (i === 11) {
                this_1.game.time.events.add(count * 100 + 100, function () {
                    // this.timerLoop = this.game.time.events.loop(Phaser.Timer.SECOND, this.onSecondPassed, this);
                    this.cardsPositions();
                    this.game.input.enabled = true;
                    this.saveChange();
                    if (GameVars_1.GameVars.gzpGameMode !== "casual") {
                        ConnectionManager_1.ConnectionManager.socket.emit("start_timer", { id: GameVars_1.GameVars.initialID });
                    }
                    else {
                        LocalServer_1.LocalServer.startTimer();
                    }
                }, this_1);
            }
        };
        var this_1 = this;
        for (var i = 0; i < GameVars_1.GameVars.pilesData.length; i++) {
            _loop_1(i);
        }
    };
    BoardManager.prototype.startedDraggingCard = function (card) {
        GameVars_1.GameVars.draggedCard = card;
        var pile = GameVars_1.GameVars.draggedCard.pile;
        if (pile) {
            pile.removeCard(GameVars_1.GameVars.draggedCard);
        }
    };
    BoardManager.prototype.nextCard = function () {
        BoardState_1.BoardState.currentInstance.board.dealPile.nextCard();
        BoardManager.currentInstance.saveChange();
        if (GameVars_1.GameVars.gzpGameMode !== "casual") {
            ConnectionManager_1.ConnectionManager.socket.emit("next_card", { id: GameVars_1.GameVars.initialID });
            BoardManager.currentInstance.showWaitingServer();
        }
        else {
            BoardManager.currentInstance.showWaitingServer();
            LocalServer_1.LocalServer.nextCard();
        }
    };
    BoardManager.prototype.showWaitingServer = function () {
        GameVars_1.GameVars.waitingServer = true;
        BoardState_1.BoardState.currentInstance.showWaitingServerLayer();
    };
    BoardManager.prototype.hideWaitingServer = function () {
        GameVars_1.GameVars.waitingServer = false;
        BoardState_1.BoardState.currentInstance.hideWaitingServerLayer();
    };
    BoardManager.prototype.doubleClick = function () {
        var piles = BoardState_1.BoardState.currentInstance.board.piles;
        var pile;
        var prevPile = GameVars_1.GameVars.draggedCard.pile ? { column: GameVars_1.GameVars.draggedCard.pile.column, foundation: GameVars_1.GameVars.draggedCard.pile.foundation } : null;
        var ok = false;
        for (var i = 0; i < piles.length; i++) {
            pile = piles[i];
            if (this.rulesOk(piles[i], false)) {
                if (GameVars_1.GameVars.draggedCard) {
                    GameVars_1.GameVars.draggedCard.release(this.rulesOk(piles[i], false), piles[i]);
                }
                ok = true;
                break;
            }
        }
        if (!ok) {
            GameVars_1.GameVars.draggedCard.release(false);
        }
        if (GameVars_1.GameVars.draggedCard.pile) {
            GameVars_1.GameVars.draggedCard.pile.addCard(GameVars_1.GameVars.draggedCard);
            if (ok) {
                var newPile = pile ? { column: pile.column, foundation: pile.foundation } : null;
                BoardManager.currentInstance.sendMoveToServer(prevPile, newPile);
            }
        }
        GameVars_1.GameVars.draggedCard = null;
        this.saveChange();
    };
    BoardManager.prototype.autoCompleteCard = function (card) {
        var piles = BoardState_1.BoardState.currentInstance.board.piles;
        // miramos primero en las 4 pilas de arriba
        for (var i = 0; i < 4; i++) {
            GameVars_1.GameVars.draggedCard = card;
            if (this.rulesOk(piles[i], false)) {
                card.autoCompleteCard(piles[i]);
                break;
            }
        }
    };
    BoardManager.prototype.autoCompleteGame = function () {
        if (!this.showAutocomplete()) {
            return;
        }
        var piles = BoardState_1.BoardState.currentInstance.board.piles;
        for (var i = 4; i < piles.length; i++) {
            if (piles[i].piledCards.length > 0) {
                for (var j = 0; j < 4; j++) {
                    GameVars_1.GameVars.draggedCard = piles[i].piledCards[piles[i].piledCards.length - 1];
                    this.game.input.enabled = false;
                    if (this.rulesOk(piles[j], false)) {
                        GameVars_1.GameVars.draggedCard.onDragStart();
                        GameVars_1.GameVars.draggedCard.autoCompleteCard(piles[j]);
                        return;
                    }
                }
            }
        }
    };
    BoardManager.prototype.allPilesEmpty = function () {
        var piles = BoardState_1.BoardState.currentInstance.board.piles;
        for (var i = 4; i < piles.length; i++) {
            if (piles[i].piledCards.length > 0) {
                return false;
            }
        }
        return true;
    };
    BoardManager.prototype.draggedCardReleased = function () {
        var board = BoardState_1.BoardState.currentInstance.board;
        var collisions = board.checkCollisions();
        var collidingPiles = collisions.collidingPiles;
        var collidingCards = collisions.collidingCards;
        // encontrar la pila mas cercana o la pila sobre la carta sobre la que la estamos dejando
        var j = 0;
        var distance = Number.MAX_VALUE;
        var pile = null;
        if (collidingPiles.length > 0) {
            for (var i = 0; i < collidingPiles.length; i++) {
                var d = Phaser.Point.distance(collidingPiles[i].position, GameVars_1.GameVars.draggedCard.position);
                if (d < distance) {
                    distance = d;
                    j = i;
                }
            }
            pile = collidingPiles[j];
        }
        else if (collidingCards.length > 0) {
            for (var i = 0; i < collidingCards.length; i++) {
                var d = Phaser.Point.distance(collidingCards[i].position, GameVars_1.GameVars.draggedCard.position);
                if (d < distance) {
                    distance = d;
                    j = i;
                }
            }
            pile = collidingCards[j].pile;
        }
        var prevPile = GameVars_1.GameVars.draggedCard.pile ? { column: GameVars_1.GameVars.draggedCard.pile.column, foundation: GameVars_1.GameVars.draggedCard.pile.foundation } : null;
        if (GameVars_1.GameVars.draggedCard) {
            GameVars_1.GameVars.draggedCard.release(this.rulesOk(pile, false), pile);
        }
        if (GameVars_1.GameVars.draggedCard.pile) {
            GameVars_1.GameVars.draggedCard.pile.addCard(GameVars_1.GameVars.draggedCard);
            var newPile = pile ? { column: pile.column, foundation: pile.foundation } : null;
            BoardManager.currentInstance.sendMoveToServer(prevPile, newPile);
        }
        GameVars_1.GameVars.draggedCard = null;
    };
    BoardManager.prototype.cardOnDealTop = function (card) {
        return BoardState_1.BoardState.currentInstance.board.dealPile.cardOnDealTop(card);
    };
    BoardManager.prototype.deleteCardDealPile = function (card) {
        BoardState_1.BoardState.currentInstance.board.dealPile.deleteCard(card);
    };
    BoardManager.prototype.showAutocomplete = function () {
        var board = BoardState_1.BoardState.currentInstance.board;
        for (var i = 4; i < board.piles.length; i++) {
            for (var j = 0; j < board.piles[i].piledCards.length; j++) {
                if (!board.piles[i].piledCards[j].turned) {
                    return false;
                }
            }
        }
        if (board.dealPile.piledCards.length !== 0 || board.dealPile.piledCardsAux.length !== 0) {
            return false;
        }
        return true;
    };
    BoardManager.prototype.win = function () {
        var piles = BoardState_1.BoardState.currentInstance.board.piles;
        return piles[0].piledCards.length === 13 && piles[1].piledCards.length === 13 &&
            piles[2].piledCards.length === 13 &&
            piles[3].piledCards.length === 13;
    };
    BoardManager.prototype.showWinner = function (win) {
        this.game.input.enabled = true;
        if (win === GameConstants_1.GameConstants.FINAL_WIN) {
            GameVars_1.GameVars.points += GameVars_1.GameVars.time;
        }
        if (!GameVars_1.GameVars.maxPoints) {
            GameVars_1.GameVars.maxPoints = 0;
        }
        if (GameVars_1.GameVars.points > GameVars_1.GameVars.maxPoints) {
            GameVars_1.GameVars.maxPoints = GameVars_1.GameVars.points;
            oMetaManager.localSetItem(GameConstants_1.GameConstants.SCORE_STATE_KEY, JSON.stringify(GameVars_1.GameVars.points));
        }
        // this.game.time.events.remove(this.timerLoop);
        if (GameVars_1.GameVars.gzpGameMode !== "casual") {
            ConnectionManager_1.ConnectionManager.socket.emit("end_game", { id: GameVars_1.GameVars.initialID, leave: win });
            ConnectionManager_1.ConnectionManager.socket.disconnect();
        }
        else {
            LocalServer_1.LocalServer.endGame(win);
        }
        GameVars_1.GameVars.paused = true;
        BoardState_1.BoardState.currentInstance.showFinishLayer(win);
    };
    BoardManager.prototype.showMenuLayer = function () {
        BoardState_1.BoardState.currentInstance.showMenuLayer();
    };
    BoardManager.prototype.hideMenuLayer = function () {
        BoardState_1.BoardState.currentInstance.hideMenuLayer();
    };
    BoardManager.prototype.removeDealPileCard = function (card) {
        BoardState_1.BoardState.currentInstance.board.dealPile.removeCard(card);
    };
    BoardManager.prototype.checks = function (needAutocomplete) {
        if (needAutocomplete && this.showAutocomplete()) {
            BoardState_1.BoardState.currentInstance.gui.showAutoComplete();
        }
        if (this.win()) {
            GameVars_1.GameVars.gameEnded = GameConstants_1.GameConstants.FINAL_WIN;
            this.showWinner(GameConstants_1.GameConstants.FINAL_WIN);
            return;
        }
        if (this.noMoves()) {
            GameVars_1.GameVars.gameEnded = GameConstants_1.GameConstants.FINAL_OUT_OF_MOVES;
            this.showWinner(GameVars_1.GameVars.gameEnded);
        }
    };
    BoardManager.prototype.noMoves = function () {
        var board = BoardState_1.BoardState.currentInstance.board;
        // miramos las cartas de las pilas
        for (var i = 4; i < board.piles.length; i++) {
            for (var j = 0; j < board.piles[i].piledCards.length; j++) {
                if (board.piles[i].piledCards[j].turned) {
                    GameVars_1.GameVars.draggedCard = board.piles[i].piledCards[j];
                    for (var k = 0; k < board.piles.length; k++) {
                        // si la carta debajo de la que estaba es la misma que a la que tiene que ir no cuenta
                        var previousCard = null;
                        if (board.piles[i].piledCards[j - 1] !== null && board.piles[i].piledCards[j - 1] !== undefined && board.piles[i].piledCards[j - 1].turned) {
                            previousCard = board.piles[i].piledCards[j - 1];
                        }
                        if (this.rulesOk(board.piles[k], true)) {
                            if (previousCard && board.piles[k].piledCards[board.piles[k].piledCards.length - 1] !== null) {
                                if (previousCard.cardValue.value === board.piles[k].piledCards[board.piles[k].piledCards.length - 1].cardValue.value) {
                                    continue;
                                }
                            }
                            // si va a las foundation piles solo cuenta si no tiene attached cards
                            if (k < 4 && j !== board.piles[i].piledCards.length - 1) {
                                continue;
                            }
                            // si es un rey en un espacio y lo movemos a otro no cuenta
                            if (k >= 4 && board.piles[k].piledCards.length === 0 && j === 0) {
                                continue;
                            }
                            GameVars_1.GameVars.draggedCard = null;
                            return false;
                        }
                    }
                }
            }
        }
        // miramos despues todas las cartas del deal pile
        for (var i = 0; i < board.dealPile.piledCardsAux.length; i++) {
            GameVars_1.GameVars.draggedCard = board.dealPile.piledCardsAux[i];
            for (var j = 0; j < board.piles.length; j++) {
                if (this.rulesOk(board.piles[j], true)) {
                    GameVars_1.GameVars.draggedCard = null;
                    return false;
                }
            }
        }
        for (var i = 0; i < board.dealPile.piledCards.length; i++) {
            GameVars_1.GameVars.draggedCard = board.dealPile.piledCards[i];
            for (var j = 0; j < board.piles.length; j++) {
                if (this.rulesOk(board.piles[j], true)) {
                    GameVars_1.GameVars.draggedCard = null;
                    return false;
                }
            }
        }
        var vecFoundation;
        var vecPiles;
        vecFoundation = new Array();
        vecPiles = new Array();
        for (var i = 0; i < board.piles.length; i++) {
            var cardValues = new Array();
            cardValues.push({ value: -1, suit: -1 });
            for (var j = 0; j < board.piles[i].piledCards.length; j++) {
                var cardValue = { value: 0, suit: 0 };
                if (board.piles[i].piledCards[j].turned) {
                    cardValue.value = board.piles[i].piledCards[j].cardValue.value;
                    cardValue.suit = board.piles[i].piledCards[j].cardValue.suit;
                }
                cardValues.push(cardValue);
            }
            if (i < 4) {
                vecFoundation.push(cardValues);
            }
            else {
                vecPiles.push(cardValues);
            }
        }
        // movemos cartas de abajo entre ellas para subir alguna
        for (var i = 0; i < vecFoundation.length; i++) {
            var card = vecFoundation[i][vecFoundation[i].length - 1];
            for (var j = 0; j < vecPiles.length; j++) {
                for (var k = 0; k < vecPiles[j].length; k++) {
                    var card2 = vecPiles[j][k];
                    if (card2.value !== 0 && card.suit === card2.suit && card.value === (card2.value - 1)) {
                        if (this.foundSameCardSuit(card2, vecPiles)) {
                            return false;
                        }
                    }
                }
            }
        }
        // bajamos cartas de la foundation pile
        return this.noMovesRecursive(vecFoundation, vecPiles);
    };
    BoardManager.prototype.foundSameCardSuit = function (card, vecPiles) {
        for (var j = 0; j < vecPiles.length; j++) {
            var card2 = vecPiles[j][vecPiles[j].length - 1];
            if (card.value === card2.value && Math.abs(card.suit - card2.suit) === 2) {
                return true;
            }
        }
    };
    BoardManager.prototype.noMovesRecursive = function (vecFoundation, vecPiles) {
        for (var i = 0; i < vecFoundation.length; i++) {
            for (var j = 0; j < vecPiles.length; j++) {
                var foundPos = vecFoundation[i].length - 1;
                var pilePos = vecPiles[j].length - 1;
                if (this.canMove(vecFoundation[i][foundPos], vecPiles[j][pilePos])) {
                    vecPiles[j].push(vecFoundation[i].pop());
                    pilePos = vecPiles[j].length - 1;
                    if (this.newMove(vecPiles[j][pilePos], vecPiles)) {
                        return false;
                    }
                    else {
                        return this.noMovesRecursive(vecFoundation, vecPiles);
                    }
                }
            }
        }
        return true;
    };
    BoardManager.prototype.newMove = function (card2, vecPiles) {
        var board = BoardState_1.BoardState.currentInstance.board;
        for (var i = 0; i < board.dealPile.piledCards.length; i++) {
            if (this.canMove(board.dealPile.piledCards[i].cardValue, card2)) {
                return true;
            }
        }
        for (var i = 0; i < board.dealPile.piledCardsAux.length; i++) {
            if (this.canMove(board.dealPile.piledCardsAux[i].cardValue, card2)) {
                return true;
            }
        }
        for (var i = 0; i < vecPiles.length; i++) {
            for (var j = 0; j < vecPiles[i].length; j++) {
                if (this.canMove(vecPiles[i][j], card2)) {
                    if (vecPiles[i][j - 1] && (vecPiles[i][j - 1].value === -1 || vecPiles[i][j - 1].value === 0)) {
                        return true;
                    }
                }
            }
        }
        return false;
    };
    BoardManager.prototype.canMove = function (card1, card2) {
        if (card1.value === -1 || card2.value === -1 || card1.value === 0 || card2.value === 0) {
            return false;
        }
        else {
            if (card1.suit === 1 || card1.suit === 3) {
                if (card2.suit === 0 || card2.suit === 2) {
                    return ((card2.value - card1.value) === 1);
                }
                else {
                    return false;
                }
            }
            else if (card1.suit === 0 || card1.suit === 2) {
                if (card2.suit === 1 || card2.suit === 3) {
                    return ((card2.value - card1.value) === 1);
                }
                else {
                    return false;
                }
            }
        }
    };
    BoardManager.prototype.cardsPositions = function () {
        var piles = BoardState_1.BoardState.currentInstance.board.piles;
        for (var i = 4; i < piles.length; i++) {
            piles[i].recalculatePositions();
        }
    };
    BoardManager.prototype.saveChange = function () {
        GameVars_1.GameVars.pilesData = [];
        var board = BoardState_1.BoardState.currentInstance.board;
        // foundation piles
        for (var i = 0; i < 4; i++) {
            var pileData_1 = { cards: [], flipped: 0 };
            for (var j = 0; j < board.piles[i].piledCards.length; j++) {
                pileData_1.cards.push(board.piles[i].piledCards[j].cardValue);
            }
            GameVars_1.GameVars.pilesData.push(pileData_1);
        }
        // piles
        for (var i = 4; i < 11; i++) {
            var pileData_2 = { cards: [], flipped: 0 };
            var firstFliped = false;
            for (var j = 0; j < board.piles[i].piledCards.length; j++) {
                pileData_2.cards.push(board.piles[i].piledCards[j].cardValue);
                if (board.piles[i].piledCards[j].turned && !firstFliped) {
                    firstFliped = true;
                    pileData_2.flipped = j;
                }
            }
            GameVars_1.GameVars.pilesData.push(pileData_2);
        }
        var pileDataAux = { cards: [], flipped: 0 };
        for (var i = 0; i < board.dealPile.piledCardsAux.length; i++) {
            pileDataAux.cards.push(board.dealPile.piledCardsAux[i].cardValue);
        }
        GameVars_1.GameVars.pilesData.push(pileDataAux);
        var pileData = { cards: [], flipped: 0 };
        for (var i = 0; i < board.dealPile.piledCards.length; i++) {
            pileData.cards.push(board.dealPile.piledCards[i].cardValue);
        }
        pileData.flipped = pileData.cards.length;
        GameVars_1.GameVars.pilesData.push(pileData);
    };
    BoardManager.prototype.compressPositions = function (pile) {
        var num = pile.y;
        for (var i = 0; i < pile.piledCards.length; i++) {
            if (i === 0) {
                num += pile.piledCards[i].height / 2;
            }
            if (pile.piledCards[i].turned) {
                num += Pile_1.Pile.CARDS_OFFSET;
            }
            else {
                num += Pile_1.Pile.CARDS_OFFSET / 2;
            }
        }
        var max = GameConstants_1.GameConstants.GAME_HEIGHT;
        return Math.ceil((num - max) / Pile_1.Pile.CARDS_OFFSET);
    };
    BoardManager.prototype.sendMoveToServer = function (prevPile, newPile, autocomplete) {
        if (newPile !== prevPile && newPile) {
            // correccion en el numero de las columnas
            if (prevPile) {
                if (!prevPile.foundation) {
                    prevPile.column += 4;
                }
            }
            else {
                prevPile = {
                    column: 11,
                    foundation: false
                };
            }
            if (newPile) {
                if (!newPile.foundation) {
                    newPile.column += 4;
                }
            }
            if (GameVars_1.GameVars.gzpGameMode !== "casual") {
                ConnectionManager_1.ConnectionManager.socket.emit("move_card", { card: GameVars_1.GameVars.draggedCard.cardValue, prevPile: prevPile, newPile: newPile, autocomplete: autocomplete, id: GameVars_1.GameVars.initialID });
                BoardManager.currentInstance.showWaitingServer();
            }
            else {
                BoardManager.currentInstance.showWaitingServer();
                LocalServer_1.LocalServer.moveCardClient({ card: GameVars_1.GameVars.draggedCard.cardValue, prevPile: prevPile, newPile: newPile, autocomplete: autocomplete });
            }
        }
    };
    BoardManager.prototype.rulesOk = function (pile, noMoves) {
        if (!pile) {
            return false;
        }
        // diferenciamos entre si la pila es foundation o no
        if (pile.foundation) {
            if (pile === GameVars_1.GameVars.draggedCard.pile && !noMoves) {
                return false;
            }
            var card1 = GameVars_1.GameVars.draggedCard.cardValue;
            var length_1 = GameVars_1.GameVars.draggedCard.attachedCards.length;
            // si esta vacio podemos meter una A de cualquier palo
            if (pile.piledCards.length === 0) {
                if (card1.value === 1) {
                    return true;
                }
                else if (card1.value !== 1) {
                    return false;
                }
            }
            // si ya tenemos alguna carta miramos que sea del mismo palo y un número por encima
            var card2 = pile.piledCards[pile.piledCards.length - 1].cardValue;
            if (card1.suit === card2.suit) {
                if ((card1.value - card2.value) === 1 && length_1 === 0) {
                    return true;
                }
                return false;
            }
            return false;
        }
        else {
            // si es la primera carta de la pila, solo se pone si es un rey
            if (pile.piledCards.length === 0) {
                var card1_1 = GameVars_1.GameVars.draggedCard.cardValue;
                if (card1_1.value === 13) {
                    return true;
                }
                return false;
            }
            var card1 = GameVars_1.GameVars.draggedCard.cardValue;
            var card2 = pile.piledCards[pile.piledCards.length - 1].cardValue;
            if (!pile.piledCards[pile.piledCards.length - 1].turned) {
                return false;
            }
            // miramos si el palo es negro(1,3) o rojo (0,2)
            // solo se apila si son de palos distintos
            if (card1.suit === 1 || card1.suit === 3) {
                if (card2.suit === 0 || card2.suit === 2) {
                    // miramos si el numero esta 1 por debajo del de la ultima carta de la pila
                    return ((card2.value - card1.value) === 1);
                }
                else {
                    return false;
                }
            }
            else if (card1.suit === 0 || card1.suit === 2) {
                if (card2.suit === 1 || card2.suit === 3) {
                    // miramos si el numero esta 1 por debajo del de la ultima carta de la pila
                    return ((card2.value - card1.value) === 1);
                }
                else {
                    return false;
                }
            }
        }
    };
    return BoardManager;
}());
exports.BoardManager = BoardManager;
